import React, { useState, useRef, useEffect } from 'react';
import { 
  FiArrowLeft, FiBell, FiSearch, FiCalendar, FiClock, FiRefreshCw,
  FiMapPin, FiPlusCircle, FiHome, FiChevronRight, FiStar, FiInfo, FiX
} from 'react-icons/fi';
import { 
  MdOutlineFlight, MdOutlineLocalAirport, MdOutlineHotel, 
  MdOutlineHome, MdOutlineCardTravel, MdOutlineTrain, 
  MdOutlineDirectionsBus, MdOutlineLocalTaxi, MdOutlineAttractions,
  MdOutlineVisa, MdOutlineDirectionsBoat, MdOutlineCurrencyExchange,
  MdOutlineHealthAndSafety
} from 'react-icons/md';
import { BsArrowLeftRight } from 'react-icons/bs';
import { RiExchangeFundsLine, RiMapPinLine, RiMapPin2Line } from 'react-icons/ri';
import { GiCommercialAirplane } from 'react-icons/gi';
import { FaCity, FaMapMarkedAlt } from 'react-icons/fa';
import { useNavigate, Link } from 'react-router-dom';
import Image2 from "../Assests/mobile-pan-india-optimized.jpg";
import Image3 from "../Assests/mobile-airport-transfer-optimized.jpg";
import bannerZeroCost from "../Assests/NewHeroImage/hero-bg-optimized.jpg";
import bannerChennaiCab from "../Assests/HerobelowBanners/banner-chennai-cab-hd-optimized.jpg";
import bannerFreeCancellation from "../Assests/HerobelowBanners/banner-free-cancellation-optimized.jpg";
import mobileBanner1 from "../Assests/MobileBanners/mobile-banner-1-optimized.jpg";
import mobileBanner2 from "../Assests/MobileBanners/mobile-banner-2-optimized.jpg";
import newHeroBg from "../Assests/NewHeroImage/hero-bg-optimized.jpg";
import WhyRideWithUs from "../components/WhyRideWithUs";
import Features from "../components/features";
import Cards from "../components/cards";
import SafetySection from "../components/safty";
import FleetTariffs from "../components/FleetTariffs";
import { getDistanceBetweenLocations, getUserCurrentLocation, searchLocations } from '../services/distanceService';
import AllPopularRoutes from '../components/AllPopularRoutes';
import FAQ from '../components/FAQ';


// Location Autocomplete Component (only used in mobile)
const MobileLocationAutocomplete = ({ value, onChange, placeholder, onCurrentLocation }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const wrapperRef = useRef(null);
  const abortRef = useRef(null);
  const debounceRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInputChange = async (e) => {
    const inputValue = e.target.value;
    onChange(inputValue);
    
    if (inputValue.length > 2) {
      if (debounceRef.current) clearTimeout(debounceRef.current);
      if (abortRef.current) abortRef.current.abort();
      const controller = new AbortController();
      abortRef.current = controller;
      setIsLoading(true);
      debounceRef.current = setTimeout(async () => {
        try {
          const results = await searchLocations(inputValue, { signal: controller.signal });
          setSuggestions(results);
          setShowSuggestions(true);
        } catch (error) {
          console.error('Location search error:', error);
        } finally {
          setIsLoading(false);
        }
      }, 250);
    } else {
      if (debounceRef.current) clearTimeout(debounceRef.current);
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    onChange(suggestion.description || suggestion.displayName);
    setShowSuggestions(false);
  };

  return (
    <div ref={wrapperRef} className="relative w-full">
      <div className="flex items-center gap-2">
        <input
          type="text"
          value={value}
          onChange={handleInputChange}
          onFocus={() => value.length > 2 && suggestions.length > 0 && setShowSuggestions(true)}
          placeholder={placeholder}
          className="w-full border-none outline-none text-sm font-medium bg-transparent"
        />
        {value && (
          <button onClick={() => onChange('')} className="text-gray-400 hover:text-gray-600">
            <FiX size={16} />
          </button>
        )}
        {onCurrentLocation && (
          <button
            onClick={onCurrentLocation}
            className="text-red-500 hover:text-red-600 text-xs font-medium flex items-center gap-1 whitespace-nowrap"
          >
            <RiMapPinLine /> Current
          </button>
        )}
      </div>
      
      {showSuggestions && suggestions.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-white rounded-lg shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
          {suggestions.map((suggestion, index) => (
            <div
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
              className="px-4 py-3 hover:bg-gray-50 cursor-pointer border-b last:border-b-0"
            >
              <div className="font-medium text-sm">{suggestion.displayName || suggestion.description}</div>
              <div className="text-xs text-gray-500 mt-0.5">{suggestion.address || suggestion.structured_formatting?.secondary_text}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Desktop version: keeps the original input styling, only adds dropdown suggestions.
const DesktopLocationAutocomplete = ({ value, onChange, placeholder, inputStyle }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const wrapperRef = useRef(null);
  const abortRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const inputValue = (value || '').trim();

    if (inputValue.length < 3) {
      setSuggestions([]);
      setShowSuggestions(false);
      if (abortRef.current) abortRef.current.abort();
      return undefined;
    }

    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    setIsLoading(true);
    const timeoutId = setTimeout(async () => {
      try {
        const results = await searchLocations(inputValue, { signal: controller.signal });
        setSuggestions(results);
        setShowSuggestions(true);
      } catch (error) {
        console.error('Location search error:', error);
      } finally {
        setIsLoading(false);
      }
    }, 250);

    return () => {
      clearTimeout(timeoutId);
      controller.abort();
    };
  }, [value]);

  const handleSelect = (suggestion) => {
    onChange(suggestion.displayName || suggestion.description || '');
    setShowSuggestions(false);
  };

  return (
    <div ref={wrapperRef} style={{ position: 'relative' }}>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => suggestions.length > 0 && setShowSuggestions(true)}
        style={inputStyle}
        autoComplete="off"
      />

      {showSuggestions && (isLoading || suggestions.length > 0) && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 10px)',
            left: 0,
            right: 0,
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: '14px',
            boxShadow: '0 18px 50px rgba(0,0,0,0.14)',
            zIndex: 999,
            maxHeight: '280px',
            overflowY: 'auto',
          }}
        >
          {isLoading && (
            <div style={{ padding: '12px 14px', fontSize: '13px', color: '#6b7280' }}>
              Searching...
            </div>
          )}
          {suggestions.map((suggestion, idx) => (
            <div
              key={`${suggestion.displayName}-${idx}`}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleSelect(suggestion)}
              style={{
                padding: '12px 14px',
                cursor: 'pointer',
                borderBottom: idx === suggestions.length - 1 ? 'none' : '1px solid #f3f4f6',
              }}
            >
              <div style={{ fontSize: '13px', fontWeight: 700, color: '#111827' }}>
                {suggestion.structured_formatting?.main_text ||
                  suggestion.city ||
                  (suggestion.displayName || '').split(',')[0]}
              </div>
              <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>
                {suggestion.displayName || suggestion.description}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const format12Hour = (time24) => {
  if (!time24) return { time: '10:00', period: 'AM' };
  const parts = time24.split(':');
  let h = parseInt(parts[0], 10);
  const m = parts[1] || '00';
  if (isNaN(h)) return { time: '10:00', period: 'AM' };
  const period = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return { time: `${String(h).padStart(2, '0')}:${m}`, period };
};

const HeroBookingSection = () => {
  const getTodayIso = () => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const minBookingDate = getTodayIso();
  const [tripType, setTripType] = useState('oneway');
  const [pickup, setPickup] = useState('');
  const [drop, setDrop] = useState('');
  const [stops, setStops] = useState([]);
  const [pickupLocation, setPickupLocation] = useState('');
  const [departureDate, setDepartureDate] = useState(() => getTodayIso());
  const [returnDate, setReturnDate] = useState(() => getTodayIso());
  const [pickupTime, setPickupTime] = useState('10:00');
  const [dropTime, setDropTime] = useState('09:45');
  const [selectedPackage, setSelectedPackage] = useState('1 hrs 10 kms');
  const [showReturnDate, setShowReturnDate] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [mobileTab, setMobileTab] = useState('outstation');
  const [mobileSubTab, setMobileSubTab] = useState('oneway');
  const [isCalculating, setIsCalculating] = useState(false);

  const handleAddStop = () => {
    if (stops.length < 4) {
      setStops([...stops, '']);
    }
  };

  const handleStopChange = (index, value) => {
    const updated = [...stops];
    updated[index] = value;
    setStops(updated);
  };

  const handleRemoveStop = (index) => {
    setStops(stops.filter((_, i) => i !== index));
  };

  const handleRouteSelect = ({ from, to }) => {
    setPickup(from);
    setDrop(to);
    setTripType('oneway');      // auto-switch to one-way tab
    setMobileTab('outstation'); // mobile tab
    setMobileSubTab('oneway');  // mobile sub-tab
  };

  const navigate = useNavigate();
  const ACCENT = '#e71204';
  const mobileHeroBanners = [
    {
      src: "https://quickride.in/images/airport-taxi.jpg",
      alt: "Luxury cab service",
      title: "Outstation Cabs",
      sub: "One-way & Round trips",
      overlay: true,
    },
    {
      src: Image2,
      alt: "PAN India cab network",
      title: "PAN India Service",
      sub: "500+ cities • 24/7 available",
      overlay: true,
    },
    {
      src: Image3,
      alt: "Airport transfers",
      title: "Airport Transfers",
      sub: "Pickup & drop • Flight tracking",
      overlay: true,
    },
    {
      src: bannerZeroCost,
      alt: "Book now at zero cost",
    },
    {
      src: bannerChennaiCab,
      alt: "Exclusive Chennai cab packages",
    },
    {
      src: bannerFreeCancellation,
      alt: "Free cancellations up to 1 hour before your trip",
    },
  ];

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = d.getDate();
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return {
      day,
      month: months[d.getMonth()],
      year: `'${String(d.getFullYear()).slice(2)}`,
      dayName: days[d.getDay()]
    };
  };

  const dep = formatDate(departureDate);
  const ret = formatDate(returnDate);
  const pickupFormatted = format12Hour(pickupTime);
  const dropFormatted = format12Hour(dropTime);

  const dropTimeRef = useRef(null);
  const departureDateRef = useRef(null);
  const returnDateRef = useRef(null);
  const pickupTimeRef = useRef(null);

  // Preload and cache all banner images on initial mount for instant zero-lag display
  useEffect(() => {
    const bannersToPreload = [
      mobileBanner1,
      mobileBanner2,
      bannerZeroCost,
      Image2,
      Image3,
      bannerFreeCancellation,
      newHeroBg,
      bannerChennaiCab
    ];
    bannersToPreload.forEach(src => {
      if (src) {
        const img = new Image();
        img.src = src;
      }
    });
  }, []);

  useEffect(() => {
    if (departureDate < minBookingDate) setDepartureDate(minBookingDate);
    if (returnDate < minBookingDate) setReturnDate(minBookingDate);
    if (returnDate < departureDate) setReturnDate(departureDate);
  }, [departureDate, returnDate, minBookingDate]);

  const tripTabs = [
    { id: 'oneway', label: 'Outstation One-Way' },
    { id: 'roundtrip', label: 'Outstation Round-Trip' },
    { id: 'airport', label: 'Airport Transfers' },
    // { id: 'hourly', label: 'Hourly Rentals', isNew: true },
  ];

  const calculateMultiStopDistance = async (from, stopsList, to) => {
    const validStops = (stopsList || []).filter(s => s && s.trim().length > 0);
    if (validStops.length === 0) {
      return await getDistanceBetweenLocations(from, to);
    }
    
    const waypoints = [from, ...validStops, to];
    let totalDistKm = 0;
    let firstDetails = null;
    let lastDetails = null;

    for (let i = 0; i < waypoints.length - 1; i++) {
      const leg = await getDistanceBetweenLocations(waypoints[i], waypoints[i + 1]);
      if (leg && leg.distance) {
        totalDistKm += parseFloat(leg.distance) || 0;
        if (i === 0) firstDetails = leg.fromDetails;
        if (i === waypoints.length - 2) lastDetails = leg.toDetails;
      } else {
        return null;
      }
    }

    return {
      distance: Math.round(totalDistKm),
      duration: `${Math.round(totalDistKm / 50 * 60)} mins`,
      fromDetails: firstDetails,
      toDetails: lastDetails,
    };
  };

  const handleSearch = async () => {
    setIsCalculating(true);
    
    try {
      const validStops = stops.filter(s => s && s.trim().length > 0);

      // Check if mobile view
      if (window.innerWidth <= 767) {
        // Mobile search logic
        let fromLocation = mobileTab === 'hourly' ? pickupLocation : pickup;
        let toLocation = mobileTab === 'hourly' ? '' : drop;
        
        // Validate based on tab
        if (mobileTab === 'hourly') {
          if (!fromLocation) {
            alert('Please enter pickup location');
            setIsCalculating(false);
            return;
          }
          
          navigate('/vehicle-selection', {
            state: {
              from: fromLocation,
              tripType: 'hourly',
              pickupDate: departureDate,
              pickupTime: `${pickupFormatted.time} ${pickupFormatted.period}`,
              service: 'Hourly Rental',
              rentalPackage: selectedPackage,
              mobileNumber: '',
              city: fromLocation
            }
          });
          setIsCalculating(false);
          return;
        }
        
        if (!fromLocation || !toLocation) {
          alert('Please enter both pickup and drop locations');
          setIsCalculating(false);
          return;
        }

        // Calculate distance for mobile
        const distance = await calculateMultiStopDistance(fromLocation, validStops, toLocation);
        
        if (distance) {
          navigate('/vehicle-selection', {
            state: {
              from: fromLocation,
              to: toLocation,
              stops: validStops,
              distance: distance.distance,
              duration: distance.duration,
              fromDetails: distance.fromDetails,
              toDetails: distance.toDetails,
              tripType: mobileSubTab === 'oneway' ? 'oneway' : 'roundtrip',
              pickupDate: departureDate,
              returnDate: mobileSubTab === 'roundtrip' ? returnDate : null,
              pickupTime: `${pickupFormatted.time} ${pickupFormatted.period}`,
              dropTime: mobileSubTab === 'roundtrip' ? `${dropFormatted.time} ${dropFormatted.period}` : null,
              service: mobileSubTab === 'oneway' ? 'One Way Trip' : 'Round Trip',
              mobileNumber: ''
            }
          });
        } else {
          alert('Could not calculate distance. Please check locations or try manual entry.');
        }
        setIsCalculating(false);
        return;
      }

      // Desktop view search
      let fromLocation = pickup;
      let toLocation = drop;
      
      if (tripType === 'hourly') {
        if (!pickupLocation) {
          alert('Please enter pickup location');
          setIsCalculating(false);
          return;
        }
        
        navigate('/vehicle-selection', {
          state: {
            from: pickupLocation,
            tripType: 'hourly',
            pickupDate: departureDate,
            pickupTime: `${pickupFormatted.time} ${pickupFormatted.period}`,
            service: 'Hourly Rental',
            rentalPackage: selectedPackage,
            mobileNumber: ''
          }
        });
        setIsCalculating(false);
        return;
      }
      
      if (!fromLocation || !toLocation) {
        alert('Please enter both pickup and drop locations');
        setIsCalculating(false);
        return;
      }

      const distance = await calculateMultiStopDistance(fromLocation, validStops, toLocation);
      
      if (distance) {
        navigate('/vehicle-selection', {
          state: {
            from: fromLocation,
            to: toLocation,
            stops: validStops,
            distance: distance.distance,
            duration: distance.duration,
            fromDetails: distance.fromDetails,
            toDetails: distance.toDetails,
            tripType: tripType,
            pickupDate: departureDate,
            returnDate: tripType === 'roundtrip' ? returnDate : null,
            pickupTime: `${pickupFormatted.time} ${pickupFormatted.period}`,
            dropTime: tripType === 'roundtrip' ? `${dropFormatted.time} ${dropFormatted.period}` : null,
            service: tripType === 'oneway' ? 'One Way Trip' :
                     tripType === 'roundtrip' ? 'Round Trip' :
                     tripType === 'airport' ? 'Airport Transfer' : 'Outstation',
            rentalPackage: selectedPackage,
            mobileNumber: ''
          }
        });
      } else {
        alert('Could not calculate distance. Please check the location names or try again.');
      }
    } catch (error) {
      console.error('Search error:', error);
      alert('An error occurred. Please try again.');
    } finally {
      setIsCalculating(false);
    }
  };

  const handleGetCurrentLocation = async (field) => {
    try {
      const location = await getUserCurrentLocation();
      const locationStr = location.shortName || location.displayName;
      
      if (field === 'pickup') {
        setPickup(locationStr);
      } else if (field === 'drop') {
        setDrop(locationStr);
      } else if (field === 'pickupLocation') {
        setPickupLocation(locationStr);
      }
    } catch (error) {
      console.error('Error getting location:', error);
      alert('Could not get your location. Please check location permissions.');
    }
  };

  const handleSwapLocations = () => {
    if (mobileTab === 'hourly') return;
    const temp = pickup;
    setPickup(drop);
    setDrop(temp);
  };

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif" }}>
      {/* ═══════════════════════════════════════════════════ */}
      {/* DESKTOP VIEW — EXACTLY AS IT WAS, NO UI CHANGES    */}
      {/* ═══════════════════════════════════════════════════ */}
      <div className="desktop-hero">
        <div style={{
          position: 'relative',
          height: '420px',
          background: "#f8f8f8",
          marginBottom: '150px'
        }}>
          <div style={{
            position: 'absolute', inset: 0,
            backgroundImage: `url(${newHeroBg})`,
            backgroundSize: 'cover', backgroundPosition: 'center',
            opacity: 1
          }} />
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(to bottom, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.02) 50%, rgba(0,0,0,0.2) 100%)'
          }} />

          <div style={{
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translate(-50%, 50%)',
            zIndex: 10,
            width: '100%',
            maxWidth: '1000px',
            padding: '0 20px'
          }}>
            <div style={{
              background: '#fff',
              borderRadius: '14px',
              boxShadow: '0 15px 45px rgba(0,0,0,0.2)',
              overflow: 'hidden'
            }}>
              {/* Trip Type Tabs */}
              <div style={{
                display: 'flex', alignItems: 'center',
                padding: '12px 20px 0',
                gap: '20px', borderBottom: '1px solid #f0f0f0'
              }}>
                {tripTabs.map((tab) => (
                  <label key={tab.id} style={{
                    display: 'flex', alignItems: 'center', gap: '6px',
                    cursor: 'pointer', paddingBottom: '11px',
                    fontSize: '13px', fontWeight: tripType === tab.id ? 600 : 400,
                    color: tripType === tab.id ? ACCENT : '#444',
                    position: 'relative'
                  }}>
                    <input
                      type="radio" name="triptype"
                      checked={tripType === tab.id}
                      onChange={() => setTripType(tab.id)}
                      style={{ accentColor: ACCENT, width: '14px', height: '14px' }}
                    />
                    {tab.label}
                    {tab.isNew && (
                      <span style={{
                        background: ACCENT, color: '#fff',
                        fontSize: '9px', fontWeight: 700,
                        padding: '1px 5px', borderRadius: '8px'
                      }}>new</span>
                    )}
                  </label>
                ))}
                <span style={{ marginLeft: 'auto', fontSize: '12px', color: '#666', paddingBottom: '11px' }}>Online Cab Booking</span>
              </div>

              {/* Form Fields */}
              <div style={{ padding: '16px 20px 12px' }}>
                {/* ONE WAY */}
                {tripType === 'oneway' && (
                  <div style={{ display: 'flex', gap: '0', alignItems: 'stretch' }}>
                    <div style={{ flex: 2.2, padding: '0 16px 0 0', borderRight: '1px solid #e8e8e8' }}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px' }}>From</div>
                      <DesktopLocationAutocomplete
                        value={pickup}
                        onChange={setPickup}
                        placeholder="Chennai"
                        inputStyle={{ border: 'none', outline: 'none', fontSize: '20px', fontWeight: 700, color: '#1a1a1a', width: '100%', padding: '0' }}
                      />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', padding: '0 12px', cursor: 'pointer' }}>
                      <div style={{ width: '28px', height: '28px', borderRadius: '50%', border: `2px solid ${ACCENT}`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: ACCENT, fontSize: '13px' }}><BsArrowLeftRight /></div>
                    </div>
                    <div style={{ flex: 2.2, padding: '0 16px', borderRight: '1px solid #e8e8e8' }}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px' }}>To</div>
                      <DesktopLocationAutocomplete
                        value={drop}
                        onChange={setDrop}
                        placeholder="Bangalore"
                        inputStyle={{ border: 'none', outline: 'none', fontSize: '20px', fontWeight: 700, color: '#1a1a1a', width: '100%', padding: '0' }}
                      />
                    </div>
                    <div style={{ flex: 1.5, padding: '0 16px', borderRight: '1px solid #e8e8e8', cursor: 'pointer' }} onClick={() => departureDateRef.current?.showPicker()}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>Departure <span style={{ color: ACCENT }}>▾</span></div>
                      <input 
                        ref={departureDateRef}
                        type="date" 
                        value={departureDate} 
                        onChange={e => setDepartureDate(e.target.value)}
                        min={minBookingDate}
                        style={{ 
                          border: 'none', 
                          outline: 'none', 
                          opacity: 0, 
                          position: 'absolute', 
                          width: '120px', 
                          height: '1px',
                          pointerEvents: 'none'
                        }} 
                      />
                      <div style={{ fontSize: '20px', fontWeight: 700, color: '#1a1a1a', lineHeight: 1.1 }}>
                        <span>{dep.day}</span><span style={{ fontSize: '13px', marginLeft: '4px' }}>{dep.month}{dep.year}</span>
                      </div>
                      <div style={{ fontSize: '11px', color: '#888' }}>{dep.dayName}</div>
                    </div>
                    <div style={{ flex: 1.5, padding: '0 0 0 16px', cursor: 'pointer' }} onClick={() => pickupTimeRef.current?.showPicker()}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>Pickup-Time <span style={{ color: ACCENT }}>▾</span></div>
                      <input 
                        ref={pickupTimeRef}
                        type="time" 
                        value={pickupTime} 
                        onChange={e => setPickupTime(e.target.value)}
                        style={{ 
                          border: 'none', 
                          outline: 'none', 
                          opacity: 0, 
                          position: 'absolute', 
                          width: '110px', 
                          height: '1px',
                          pointerEvents: 'none'
                        }} 
                      />
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                        <span style={{ fontSize: '20px', fontWeight: 700, color: '#1a1a1a' }}>{pickupFormatted.time}</span>
                        <span style={{ fontSize: '13px', fontWeight: 600, color: '#1a1a1a' }}>{pickupFormatted.period}</span>
                      </div>
                    </div>
                  </div>
                )}

                {/* ROUND TRIP */}
                {tripType === 'roundtrip' && (
                  <div style={{ display: 'flex', gap: '0', alignItems: 'stretch' }}>
                    <div style={{ flex: 2, padding: '0 14px 0 0', borderRight: '1px solid #e8e8e8' }}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px' }}>From</div>
                      <DesktopLocationAutocomplete
                        value={pickup}
                        onChange={setPickup}
                        placeholder="Mumbai"
                        inputStyle={{ border: 'none', outline: 'none', fontSize: '20px', fontWeight: 700, color: '#1a1a1a', width: '100%', padding: '0' }}
                      />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', padding: '0 12px', cursor: 'pointer' }}>
                      <div style={{ width: '28px', height: '28px', borderRadius: '50%', border: `2px solid ${ACCENT}`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: ACCENT, fontSize: '13px' }}><BsArrowLeftRight /></div>
                    </div>
                    <div style={{ flex: 2, padding: '0 14px', borderRight: '1px solid #e8e8e8' }}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px' }}>To</div>
                      <DesktopLocationAutocomplete
                        value={drop}
                        onChange={setDrop}
                        placeholder="Pune"
                        inputStyle={{ border: 'none', outline: 'none', fontSize: '20px', fontWeight: 700, color: '#1a1a1a', width: '100%', padding: '0' }}
                      />
                    </div>
                    <div style={{ flex: 1.3, padding: '0 14px', borderRight: '1px solid #e8e8e8', cursor: 'pointer' }} onClick={() => departureDateRef.current?.showPicker()}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>Departure <span style={{ color: ACCENT }}>▾</span></div>
                      <input 
                        ref={departureDateRef}
                        type="date" 
                        value={departureDate} 
                        onChange={e => setDepartureDate(e.target.value)} 
                        min={minBookingDate}
                        style={{ 
                          border: 'none', 
                          outline: 'none', 
                          opacity: 0, 
                          position: 'absolute', 
                          width: '120px', 
                          height: '1px',
                          pointerEvents: 'none'
                        }} 
                      />
                      <div style={{ fontSize: '20px', fontWeight: 700, color: '#1a1a1a', lineHeight: 1.1 }}>
                        <span>{dep.day}</span><span style={{ fontSize: '13px', marginLeft: '4px' }}>{dep.month}{dep.year}</span>
                      </div>
                      <div style={{ fontSize: '11px', color: '#888' }}>{dep.dayName}</div>
                    </div>
                    <div style={{ flex: 1.3, padding: '0 14px', borderRight: '1px solid #e8e8e8', cursor: 'pointer' }} onClick={() => returnDateRef.current?.showPicker()}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>Return <span style={{ color: ACCENT }}>▾</span></div>
                      <input 
                        ref={returnDateRef}
                        type="date" 
                        value={returnDate} 
                        onChange={e => setReturnDate(e.target.value)} 
                        min={departureDate < minBookingDate ? minBookingDate : departureDate}
                        style={{ 
                          border: 'none', 
                          outline: 'none', 
                          opacity: 0, 
                          position: 'absolute', 
                          width: '120px', 
                          height: '1px',
                          pointerEvents: 'none'
                        }} 
                      />
                      <div style={{ fontSize: '20px', fontWeight: 700, color: '#1a1a1a', lineHeight: 1.1 }}>
                        <span>{ret.day}</span><span style={{ fontSize: '13px', marginLeft: '4px' }}>{ret.month}{ret.year}</span>
                      </div>
                      <div style={{ fontSize: '11px', color: '#888' }}>{ret.dayName}</div>
                    </div>
                    <div style={{ flex: 1.2, padding: '0 14px', borderRight: '1px solid #e8e8e8', cursor: 'pointer' }} onClick={() => pickupTimeRef.current?.showPicker()}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>Pickup-Time <span style={{ color: ACCENT }}>▾</span></div>
                      <input 
                        ref={pickupTimeRef}
                        type="time" 
                        value={pickupTime} 
                        onChange={e => setPickupTime(e.target.value)}
                        style={{ 
                          border: 'none', 
                          outline: 'none', 
                          opacity: 0, 
                          position: 'absolute', 
                          width: '100px', 
                          height: '1px',
                          pointerEvents: 'none'
                        }} 
                      />
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                        <span style={{ fontSize: '20px', fontWeight: 700, color: '#1a1a1a' }}>{pickupFormatted.time}</span>
                        <span style={{ fontSize: '12px', fontWeight: 600 }}>{pickupFormatted.period}</span>
                      </div>
                    </div>
                    <div style={{ flex: 1.2, padding: '0 0 0 14px', cursor: 'pointer' }} onClick={() => dropTimeRef.current?.showPicker()}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px' }}>Drop Time</div>
                      <input 
                        ref={dropTimeRef}
                        type="time" 
                        value={dropTime} 
                        onChange={e => setDropTime(e.target.value)}
                        style={{ 
                          border: 'none', 
                          outline: 'none', 
                          opacity: 0, 
                          position: 'absolute', 
                          width: '100px', 
                          height: '1px',
                          pointerEvents: 'none'
                        }} 
                      />
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                        <span style={{ fontSize: '20px', fontWeight: 700, color: dropTime ? '#1a1a1a' : '#ccc' }}>{dropFormatted.time}</span>
                        <span style={{ fontSize: '12px', fontWeight: 600, color: dropTime ? '#1a1a1a' : '#ccc' }}>{dropFormatted.period}</span>
                      </div>
                    </div>
                  </div>
                )}

                {/* AIRPORT TRANSFERS */}
                {tripType === 'airport' && (
                  <div style={{ display: 'flex', gap: '0', alignItems: 'stretch' }}>
                    <div style={{ flex: 2, padding: '0 14px 0 0', borderRight: '1px solid #e8e8e8' }}>
                      <div style={{ fontSize: '11px', color: '#888', fontWeight: 600, letterSpacing: '0.5px', marginBottom: '2px' }}>FROM</div>
                      <DesktopLocationAutocomplete
                        value={pickup}
                        onChange={setPickup}
                        placeholder="Pick up Location"
                        inputStyle={{ border: 'none', outline: 'none', fontSize: '18px', fontWeight: 700, color: '#1a1a1a', width: '100%', padding: '0' }}
                      />
                    </div>
                    <div style={{ flex: 2, padding: '0 14px', borderRight: '1px solid #e8e8e8' }}>
                      <div style={{ fontSize: '11px', color: '#888', fontWeight: 600, letterSpacing: '0.5px', marginBottom: '2px' }}>TO</div>
                      <DesktopLocationAutocomplete
                        value={drop}
                        onChange={setDrop}
                        placeholder="Drop Location"
                        inputStyle={{ border: 'none', outline: 'none', fontSize: '18px', fontWeight: 700, color: '#1a1a1a', width: '100%', padding: '0' }}
                      />
                    </div>
                    <div style={{ flex: 1.5, padding: '0 14px', borderRight: '1px solid #e8e8e8', cursor: 'pointer' }} onClick={() => departureDateRef.current?.showPicker()}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>Departure <span style={{ color: ACCENT }}>▾</span></div>
                      <input 
                        ref={departureDateRef}
                        type="date" 
                        value={departureDate} 
                        onChange={e => setDepartureDate(e.target.value)} 
                        min={minBookingDate}
                        style={{ 
                          border: 'none', 
                          outline: 'none', 
                          opacity: 0, 
                          position: 'absolute', 
                          width: '120px', 
                          height: '1px',
                          pointerEvents: 'none'
                        }} 
                      />
                      <div style={{ fontSize: '20px', fontWeight: 700, color: '#1a1a1a', lineHeight: 1.1 }}>
                        <span>{dep.day}</span><span style={{ fontSize: '13px', marginLeft: '4px' }}>{dep.month}{dep.year}</span>
                      </div>
                      <div style={{ fontSize: '11px', color: '#888' }}>{dep.dayName}</div>
                    </div>
                    <div style={{ flex: 1.5, padding: '0 0 0 14px', cursor: 'pointer' }} onClick={() => pickupTimeRef.current?.showPicker()}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>Pickup-Time <span style={{ color: ACCENT }}>▾</span></div>
                      <input 
                        ref={pickupTimeRef}
                        type="time" 
                        value={pickupTime} 
                        onChange={e => setPickupTime(e.target.value)}
                        style={{ 
                          border: 'none', 
                          outline: 'none', 
                          opacity: 0, 
                          position: 'absolute', 
                          width: '110px', 
                          height: '1px',
                          pointerEvents: 'none'
                        }} 
                      />
                      <div>
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                          <span style={{ fontSize: '20px', fontWeight: 700, color: '#1a1a1a' }}>{pickupFormatted.time}</span>
                          <span style={{ fontSize: '13px', fontWeight: 600 }}>{pickupFormatted.period}</span>
                        </div>
                        <div style={{ fontSize: '10px', color: '#888' }}>pick up time as per journey city timezone</div>
                      </div>
                    </div>
                  </div>
                )}

                {/* HOURLY RENTALS */}
                {tripType === 'hourly' && (
                  <div style={{ display: 'flex', gap: '0', alignItems: 'stretch' }}>
                    <div style={{ flex: 2, padding: '0 14px 0 0', borderRight: '1px solid #e8e8e8' }}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px' }}>Pickup Location</div>
                      <DesktopLocationAutocomplete
                        value={pickupLocation}
                        onChange={setPickupLocation}
                        placeholder="Bangalore"
                        inputStyle={{ border: 'none', outline: 'none', fontSize: '20px', fontWeight: 700, color: '#1a1a1a', width: '100%', padding: '0' }}
                      />
                      <div style={{ fontSize: '11px', color: '#888' }}>Bangalore</div>
                    </div>
                    <div style={{ flex: 1.5, padding: '0 14px', borderRight: '1px solid #e8e8e8', cursor: 'pointer' }} onClick={() => departureDateRef.current?.showPicker()}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>Pickup Date <span style={{ color: ACCENT }}>▾</span></div>
                      <input 
                        ref={departureDateRef}
                        type="date" 
                        value={departureDate} 
                        onChange={e => setDepartureDate(e.target.value)} 
                        min={minBookingDate}
                        style={{ 
                          border: 'none', 
                          outline: 'none', 
                          opacity: 0, 
                          position: 'absolute', 
                          width: '120px', 
                          height: '1px',
                          pointerEvents: 'none'
                        }} 
                      />
                      <div style={{ fontSize: '20px', fontWeight: 700, color: '#1a1a1a', lineHeight: 1.1 }}>
                        <span>{dep.day}</span><span style={{ fontSize: '13px', marginLeft: '4px' }}>{dep.month}{dep.year}</span>
                      </div>
                      <div style={{ fontSize: '11px', color: '#888' }}>{dep.dayName}</div>
                    </div>
                    <div style={{ flex: 1.5, padding: '0 14px', borderRight: '1px solid #e8e8e8', cursor: 'pointer' }} onClick={() => pickupTimeRef.current?.showPicker()}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>Pickup-Time <span style={{ color: ACCENT }}>▾</span></div>
                      <input 
                        ref={pickupTimeRef}
                        type="time" 
                        value={pickupTime} 
                        onChange={e => setPickupTime(e.target.value)}
                        style={{ 
                          border: 'none', 
                          outline: 'none', 
                          opacity: 0, 
                          position: 'absolute', 
                          width: '110px', 
                          height: '1px',
                          pointerEvents: 'none'
                        }} 
                      />
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                        <span style={{ fontSize: '20px', fontWeight: 700, color: '#1a1a1a' }}>{pickupFormatted.time}</span>
                        <span style={{ fontSize: '13px', fontWeight: 600 }}>{pickupFormatted.period}</span>
                      </div>
                    </div>
                    <div style={{ flex: 1.5, padding: '0 0 0 14px' }}>
                      <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px' }}>Select Package</div>
                      <select value={selectedPackage} onChange={e => setSelectedPackage(e.target.value)}
                        style={{ border: 'none', outline: 'none', fontSize: '18px', fontWeight: 700, color: '#1a1a1a', background: 'transparent', cursor: 'pointer' }}>
                        <option>1 hrs 10 kms</option>
                        <option>2 hrs 20 kms</option>
                        <option>4 hrs 40 kms</option>
                        <option>8 hrs 80 kms</option>
                      </select>
                    </div>
                  </div>
                )}

                {(tripType === 'oneway' || tripType === 'roundtrip') && (
                  <div style={{ marginTop: '10px' }}>
                    {stops.length > 0 && (
                      <div style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {stops.map((stop, idx) => (
                          <div 
                            key={idx} 
                            style={{ 
                              display: 'flex', 
                              alignItems: 'center', 
                              gap: '10px', 
                              background: '#f9fafb', 
                              padding: '6px 14px', 
                              borderRadius: '8px', 
                              border: '1px solid #e5e7eb' 
                            }}
                          >
                            <div style={{ 
                              fontSize: '11px', 
                              fontWeight: 700, 
                              color: ACCENT, 
                              background: 'rgba(231,18,4,0.08)',
                              padding: '2px 8px',
                              borderRadius: '4px',
                              whiteSpace: 'nowrap'
                            }}>
                              STOP {idx + 1}
                            </div>
                            <div style={{ flex: 1 }}>
                              <DesktopLocationAutocomplete
                                value={stop}
                                onChange={(val) => handleStopChange(idx, val)}
                                placeholder={`Enter stop ${idx + 1} location (e.g. Vellore)`}
                                inputStyle={{ 
                                  border: 'none', 
                                  outline: 'none', 
                                  fontSize: '14px', 
                                  fontWeight: 600, 
                                  color: '#1a1a1a', 
                                  width: '100%', 
                                  background: 'transparent',
                                  padding: 0
                                }}
                              />
                            </div>
                            <button
                              type="button"
                              onClick={() => handleRemoveStop(idx)}
                              style={{ 
                                background: 'none', 
                                border: 'none', 
                                cursor: 'pointer', 
                                color: '#9ca3af', 
                                fontSize: '16px', 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '4px',
                                borderRadius: '4px',
                                transition: 'color 0.2s'
                              }}
                              title="Remove stop"
                              onMouseEnter={(e) => e.currentTarget.style.color = ACCENT}
                              onMouseLeave={(e) => e.currentTarget.style.color = '#9ca3af'}
                            >
                              <FiX />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}

                    {stops.length < 4 && (
                      <button 
                        type="button"
                        onClick={handleAddStop}
                        style={{ 
                          background: 'none', 
                          border: 'none', 
                          cursor: 'pointer', 
                          color: ACCENT, 
                          fontSize: '13px', 
                          fontWeight: 600, 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: '6px',
                          padding: '2px 0'
                        }}
                      >
                        <FiPlusCircle /> {stops.length > 0 ? '+ Add Another Stop' : '+ Add Stops'}
                        <span style={{ background: ACCENT, color: '#fff', fontSize: '9px', fontWeight: 700, padding: '1px 5px', borderRadius: '8px' }}>new</span>
                      </button>
                    )}
                  </div>
                )}
              </div>

              <div style={{ padding: '0 20px 16px', display: 'flex', justifyContent: 'center' }}>
                <button 
                  onClick={handleSearch}
                  disabled={isCalculating}
                  style={{
                    background: `linear-gradient(135deg, ${ACCENT}, #ff3a1f)`,
                    color: '#fff', 
                    border: 'none', 
                    borderRadius: '24px',
                    padding: '10px 52px', 
                    fontSize: '15px', 
                    fontWeight: 700,
                    letterSpacing: '0.8px', 
                    cursor: isCalculating ? 'not-allowed' : 'pointer',
                    boxShadow: `0 3px 14px rgba(231,18,4,0.35)`,
                    transition: 'all 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    opacity: isCalculating ? 0.7 : 1
                  }}
                >
                  {isCalculating ? (
                    <>
                      <div className="spinner" style={{
                        width: '18px',
                        height: '18px',
                        border: '2.5px solid #fff',
                        borderTop: '2.5px solid transparent',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                      }} />
                      SEACHING CABS NEAR BY YOU...
                    </>
                  ) : (
                    <>
                      <FiSearch /> SEARCH
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        <Features/>
        <Cards/>
        <div>
          
          <FleetTariffs/>
          <WhyRideWithUs/>
          <SafetySection/>
          <AllPopularRoutes onRouteSelect={handleRouteSelect} />
         <FAQ/>
        </div>
      </div>

      {/* ═══════════════════════════════════════════════════ */}
      {/* MOBILE VIEW — Only changing inputs to autocomplete   */}
      {/* ═══════════════════════════════════════════════════ */}
      <div className="mobile-hero">
        <div style={{
          background: '#f2f3f7',
          minHeight: '100vh',
          fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif",
          maxWidth: '430px',
          margin: '0 auto',
          marginTop: '-70px',
        }}>
          {/* Banner Slider */}
          <div style={{ padding: '16px 16px 8px', background: '#f2f3f7' }}>
            <div style={{
              position: 'relative',
              width: '100%',
              height: '180px',
              borderRadius: '20px',
              overflow: 'hidden',
              boxShadow: '0 10px 25px rgba(0,0,0,0.1)'
            }}>
              <div style={{
                display: 'flex',
                width: '600%',
                height: '100%',
                animation: 'mobileHeroSlide 18s infinite'
              }}>
                <div style={{ width: '16.666%', height: '100%', position: 'relative', background: '#e5e7eb' }}>
                  <img src={mobileBanner1} alt="Bhubaneswar Cab Packages" loading="eager" fetchPriority="high" decoding="async" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                </div>
               
                <div style={{ width: '16.666%', height: '100%', position: 'relative', background: '#e5e7eb' }}>
                  <img src={mobileBanner2} alt="Cab Packages" loading="eager" fetchPriority="high" decoding="async" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                </div>
                <div style={{ width: '16.666%', height: '100%', position: 'relative', background: '#e5e7eb' }}>
                  <img src={bannerZeroCost} alt="Book now at zero cost" loading="eager" fetchPriority="high" decoding="async" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                </div>
                 <div style={{ width: '16.666%', height: '100%', position: 'relative', background: '#e5e7eb' }}>
                  <img src={Image2} alt="PAN India cab network" loading="eager" fetchPriority="high" decoding="async" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '20px 16px', background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)', color: '#fff' }}>
                    <h3 style={{ fontSize: '18px', fontWeight: 700, margin: '0 0 4px' }}>PAN India Service</h3>
                    <p style={{ fontSize: '12px', margin: 0, opacity: 0.9 }}>500+ cities • 24/7 available</p>
                  </div>
                </div>
                <div style={{ width: '16.666%', height: '100%', position: 'relative', background: '#e5e7eb' }}>
                  <img src={Image3} alt="Airport transfers" loading="eager" fetchPriority="high" decoding="async" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '20px 16px', background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)', color: '#fff' }}>
                    <h3 style={{ fontSize: '18px', fontWeight: 700, margin: '0 0 4px' }}>Airport Transfers</h3>
                    <p style={{ fontSize: '12px', margin: 0, opacity: 0.9 }}>Pickup & drop • Flight tracking</p>
                  </div>
                </div>
                <div style={{ width: '16.666%', height: '100%', position: 'relative', background: '#e5e7eb' }}>
                  <img src={bannerFreeCancellation} alt="Free cancellations up to 1 hour before your trip" loading="eager" fetchPriority="high" decoding="async" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                </div>
              </div>
              <div style={{ position: 'absolute', bottom: '10px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '8px', zIndex: 2 }}>
                {[1,2,3,4,5,6].map(i => (
                  <div key={i} style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#fff', opacity: 0.5 }} />
                ))}
              </div>
            </div>
          </div>

          {/* Tab Switcher */}
          <div style={{ padding: '8px 16px 0' }}>
            <div style={{
              background: ACCENT,
              borderRadius: '14px',
              padding: '4px',
              display: 'flex',
              gap: '2px',
              width: '100%',
              maxWidth: '380px',
              minWidth: '280px',
              margin: '0 auto'
            }}>
              {[
                { id: 'outstation', label: 'Outstation' },
                { id: 'airport', label: 'Airport' },
                { id: 'hourly', label: 'Hourly' }
              ].map(tab => (
                <button 
                  key={tab.id} 
                  onClick={() => {
                    setMobileTab(tab.id);
                    if (tab.id === 'outstation') setMobileSubTab('oneway');
                  }} 
                  style={{
                    flex: '1 1 0px',
                    minWidth: '80px',
                    padding: '12px 4px',
                    borderRadius: '12px',
                    border: 'none',
                    background: mobileTab === tab.id ? '#fff' : 'transparent',
                    color: mobileTab === tab.id ? ACCENT : 'rgba(255,255,255,0.9)',
                    fontSize: 'clamp(12px, 3.5vw, 14px)',
                    fontWeight: mobileTab === tab.id ? 700 : 500,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: mobileTab === tab.id ? '0 4px 12px rgba(0,0,0,0.2)' : 'none',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          {/* Main Card */}
          <div style={{ margin: '16px 16px 0', background: '#fff', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 -4px 20px rgba(0,0,0,0.08)' }}>
            {/* Outstation Sub-tabs */}
            {mobileTab === 'outstation' && (
              <div style={{ padding: '16px 16px 0' }}>
                <div style={{ display: 'flex', gap: '10px' }}>
                  {[
                    { id: 'oneway', label: 'One Way', sub: 'Get dropped off' },
                    { id: 'roundtrip', label: 'Round Trip', sub: 'Keep cab till return' }
                  ].map(opt => (
                    <button key={opt.id} onClick={() => setMobileSubTab(opt.id)} style={{
                      flex: 1, padding: '12px',
                      borderRadius: '12px',
                      border: `2px solid ${mobileSubTab === opt.id ? ACCENT : '#e8e8e8'}`,
                      background: mobileSubTab === opt.id ? '#fff5f4' : '#fafafa',
                      cursor: 'pointer',
                      textAlign: 'left',
                      transition: 'all 0.2s'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '3px' }}>
                        <div style={{
                          width: '18px', height: '18px', borderRadius: '50%',
                          border: `2px solid ${mobileSubTab === opt.id ? ACCENT : '#ccc'}`,
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          flexShrink: 0
                        }}>
                          {mobileSubTab === opt.id && <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: ACCENT }} />}
                        </div>
                        <span style={{ fontSize: '13px', fontWeight: 700, color: '#1a1a1a' }}>{opt.label}</span>
                      </div>
                      <div style={{ fontSize: '11px', color: '#999', marginLeft: '26px' }}>{opt.sub}</div>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Route Card */}
            <div style={{ padding: '16px' }}>
              <div style={{ background: '#f8f9fb', borderRadius: '16px', overflow: 'hidden', border: '1px solid #ececec' }}>
                {/* FROM field - Using Autocomplete for mobile */}
                {mobileTab !== 'hourly' && (
                  <div style={{ display: 'flex', alignItems: 'center', padding: '16px', borderBottom: '1px solid #ececec', gap: '14px', background: '#fff' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', flexShrink: 0 }}>
                      <div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#fff', border: '3px solid #555', flexShrink: 0 }} />
                      <div style={{ width: '1.5px', height: '22px', background: '#ddd' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '10px', color: '#999', fontWeight: 700, letterSpacing: '0.8px', marginBottom: '3px' }}>FROM</div>
                      <MobileLocationAutocomplete
                        value={pickup}
                        onChange={setPickup}
                        placeholder="Enter pickup city"
                        onCurrentLocation={() => handleGetCurrentLocation('pickup')}
                      />
                    </div>
                    <button 
                      onClick={handleSwapLocations}
                      style={{
                        width: '32px', height: '32px', borderRadius: '50%',
                        background: `rgba(231,18,4,0.08)`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: ACCENT, fontSize: '16px', flexShrink: 0, cursor: 'pointer',
                        border: `1.5px solid rgba(231,18,4,0.2)`
                      }}
                    >
                      <RiExchangeFundsLine />
                    </button>
                  </div>
                )}

                {/* Hourly FROM - Using Autocomplete */}
                {mobileTab === 'hourly' && (
                  <div style={{ display: 'flex', alignItems: 'center', padding: '16px', borderBottom: '1px solid #ececec', gap: '14px', background: '#fff' }}>
                    <div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#fff', border: '3px solid #555', flexShrink: 0 }} />
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '10px', color: '#999', fontWeight: 700, letterSpacing: '0.8px', marginBottom: '3px' }}>PICKUP CITY</div>
                      <MobileLocationAutocomplete
                        value={pickupLocation}
                        onChange={setPickupLocation}
                        placeholder="Enter city"
                        onCurrentLocation={() => handleGetCurrentLocation('pickupLocation')}
                      />
                    </div>
                  </div>
                )}

                {/* TO field - Using Autocomplete */}
                {mobileTab !== 'hourly' && (
                  <div style={{ display: 'flex', alignItems: 'center', padding: '16px', borderBottom: '1px solid #ececec', gap: '14px', background: '#fff' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', flexShrink: 0 }}>
                      <div style={{ width: '1.5px', height: '22px', background: '#ddd' }} />
                      <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: '#fff', border: '3px solid #555', flexShrink: 0 }} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '10px', color: '#999', fontWeight: 700, letterSpacing: '0.8px', marginBottom: '3px' }}>TO</div>
                      <MobileLocationAutocomplete
                        value={drop}
                        onChange={setDrop}
                        placeholder="Enter destination city"
                        onCurrentLocation={() => handleGetCurrentLocation('drop')}
                      />
                    </div>
                  </div>
                )}

                {/* Add Stop in Mobile */}
                {mobileTab === 'outstation' && (
                  <div>
                    {stops.map((stop, idx) => (
                      <div key={idx} style={{ display: 'flex', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid #ececec', gap: '10px', background: '#fafafa' }}>
                        <div style={{ fontSize: '10px', color: ACCENT, fontWeight: 700, letterSpacing: '0.8px', flexShrink: 0, background: 'rgba(231,18,4,0.08)', padding: '2px 6px', borderRadius: '4px' }}>
                          STOP {idx + 1}
                        </div>
                        <div style={{ flex: 1 }}>
                          <MobileLocationAutocomplete
                            value={stop}
                            onChange={(val) => handleStopChange(idx, val)}
                            placeholder={`Enter stop ${idx + 1} city`}
                          />
                        </div>
                        <button
                          type="button"
                          onClick={() => handleRemoveStop(idx)}
                          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: '18px', padding: '4px' }}
                        >
                          <FiX />
                        </button>
                      </div>
                    ))}

                    {stops.length < 4 && (
                      <div style={{ padding: '12px 16px', borderBottom: '1px solid #ececec', background: '#fff' }}>
                        <button 
                          type="button"
                          onClick={handleAddStop}
                          style={{
                            background: 'none', border: 'none', cursor: 'pointer',
                            display: 'flex', alignItems: 'center', gap: '10px',
                            color: ACCENT, fontSize: '13px', fontWeight: 600,
                            padding: 0
                          }}
                        >
                          <div style={{
                            width: '26px', height: '26px', borderRadius: '50%',
                            border: `2px dashed ${ACCENT}`,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '16px', color: ACCENT, position: 'relative', flexShrink: 0
                          }}>
                            <FiPlusCircle />
                          </div>
                          <span>{stops.length > 0 ? '+ Add Another Stop' : '+ Add a Stop'}</span>
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {/* Date & Time fields */}
                {mobileTab === 'outstation' && mobileSubTab === 'oneway' && (
                  <div style={{ display: 'flex', alignItems: 'center', padding: '16px', borderBottom: '1px solid #ececec', gap: '14px', background: '#fff' }}>
                    <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: `rgba(231,18,4,0.08)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>
                      <FiCalendar />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '10px', color: '#999', fontWeight: 700, letterSpacing: '0.8px', marginBottom: '3px' }}>TRIP START</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ flex: 1 }}>
                          <input 
                            type="date" 
                            value={departureDate} 
                            onChange={e => setDepartureDate(e.target.value)}
                            min={minBookingDate}
                            style={{ border: 'none', outline: 'none', fontSize: '15px', fontWeight: 600, color: '#1a1a1a', background: 'transparent', padding: 0, width: '100%', cursor: 'pointer' }} 
                          />
                        </div>
                        <div style={{ width: '1px', height: '30px', background: '#ececec' }} />
                        <div style={{ flex: 0.8 }}>
                          <input 
                            type="time" 
                            value={pickupTime} 
                            onChange={e => setPickupTime(e.target.value)}
                            style={{ border: 'none', outline: 'none', fontSize: '15px', fontWeight: 600, color: '#1a1a1a', background: 'transparent', padding: 0, width: '100%', cursor: 'pointer' }} 
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Round Trip Date/Time */}
                {mobileTab === 'outstation' && mobileSubTab === 'roundtrip' && (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center', padding: '16px', borderBottom: '1px solid #ececec', gap: '14px', background: '#fff' }}>
                      <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: `rgba(231,18,4,0.08)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>
                        <FiRefreshCw />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '10px', color: '#999', fontWeight: 700, letterSpacing: '0.8px', marginBottom: '3px' }}>RETURN DETAILS</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <div style={{ flex: 1 }}>
                            <input type="date" value={returnDate} onChange={e => setReturnDate(e.target.value)} min={departureDate < minBookingDate ? minBookingDate : departureDate} style={{ border: 'none', outline: 'none', fontSize: '15px', fontWeight: 600, color: '#1a1a1a', background: 'transparent', padding: 0, width: '100%', cursor: 'pointer' }} />
                          </div>
                          <div style={{ width: '1px', height: '30px', background: '#ececec' }} />
                          <div style={{ flex: 0.8 }}>
                            <input type="time" value={dropTime} onChange={e => setDropTime(e.target.value)} style={{ border: 'none', outline: 'none', fontSize: '15px', fontWeight: 600, color: '#1a1a1a', background: 'transparent', padding: 0, width: '100%', cursor: 'pointer' }} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', padding: '16px', borderBottom: '1px solid #ececec', gap: '14px', background: '#fff' }}>
                      <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: `rgba(231,18,4,0.08)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>
                        <FiCalendar />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '10px', color: '#999', fontWeight: 700, letterSpacing: '0.8px', marginBottom: '3px' }}>PICKUP DETAILS</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <div style={{ flex: 1 }}>
                            <input type="date" value={departureDate} onChange={e => setDepartureDate(e.target.value)} min={minBookingDate} style={{ border: 'none', outline: 'none', fontSize: '15px', fontWeight: 600, color: '#1a1a1a', background: 'transparent', padding: 0, width: '100%', cursor: 'pointer' }} />
                          </div>
                          <div style={{ width: '1px', height: '30px', background: '#ececec' }} />
                          <div style={{ flex: 0.8 }}>
                            <input type="time" value={pickupTime} onChange={e => setPickupTime(e.target.value)} style={{ border: 'none', outline: 'none', fontSize: '15px', fontWeight: 600, color: '#1a1a1a', background: 'transparent', padding: 0, width: '100%', cursor: 'pointer' }} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* Airport Date/Time */}
                {mobileTab === 'airport' && (
                  <div style={{ display: 'flex', alignItems: 'center', padding: '16px', borderBottom: '1px solid #ececec', gap: '14px', background: '#fff' }}>
                    <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: `rgba(231,18,4,0.08)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>
                      <FiCalendar />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '10px', color: '#999', fontWeight: 700, letterSpacing: '0.8px', marginBottom: '3px' }}>FLIGHT DATE & TIME</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ flex: 1 }}>
                          <input type="date" value={departureDate} onChange={e => setDepartureDate(e.target.value)} min={minBookingDate} style={{ border: 'none', outline: 'none', fontSize: '15px', fontWeight: 600, color: '#1a1a1a', background: 'transparent', padding: 0, width: '100%', cursor: 'pointer' }} />
                        </div>
                        <div style={{ width: '1px', height: '30px', background: '#ececec' }} />
                        <div style={{ flex: 0.8 }}>
                          <input type="time" value={pickupTime} onChange={e => setPickupTime(e.target.value)} style={{ border: 'none', outline: 'none', fontSize: '15px', fontWeight: 600, color: '#1a1a1a', background: 'transparent', padding: 0, width: '100%', cursor: 'pointer' }} />
                        </div>
                      </div>
                      <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>As per flight arrival time</div>
                    </div>
                  </div>
                )}

                {/* Hourly Package */}
                {mobileTab === 'hourly' && (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center', padding: '16px', borderBottom: '1px solid #ececec', gap: '14px', background: '#fff' }}>
                      <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: `rgba(231,18,4,0.08)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>
                        <FiCalendar />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '10px', color: '#999', fontWeight: 700, letterSpacing: '0.8px', marginBottom: '3px' }}>PICKUP DATE & TIME</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <div style={{ flex: 1 }}>
                            <input type="date" value={departureDate} onChange={e => setDepartureDate(e.target.value)} min={minBookingDate} style={{ border: 'none', outline: 'none', fontSize: '15px', fontWeight: 600, color: '#1a1a1a', background: 'transparent', padding: 0, width: '100%', cursor: 'pointer' }} />
                          </div>
                          <div style={{ width: '1px', height: '30px', background: '#ececec' }} />
                          <div style={{ flex: 0.8 }}>
                            <input type="time" value={pickupTime} onChange={e => setPickupTime(e.target.value)} style={{ border: 'none', outline: 'none', fontSize: '15px', fontWeight: 600, color: '#1a1a1a', background: 'transparent', padding: 0, width: '100%', cursor: 'pointer' }} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', padding: '16px', gap: '14px', background: '#fff' }}>
                      <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: `rgba(231,18,4,0.08)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>
                        <FiClock />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '10px', color: '#999', fontWeight: 700, letterSpacing: '0.8px', marginBottom: '3px' }}>SELECT PACKAGE</div>
                        <select 
                          value={selectedPackage} 
                          onChange={e => setSelectedPackage(e.target.value)}
                          style={{ border: 'none', outline: 'none', fontSize: '15px', fontWeight: 600, color: '#1a1a1a', background: 'transparent', cursor: 'pointer', width: '100%', padding: 0 }}
                        >
                          <option>1hr 10kms</option>
                          <option>2hrs 20kms</option>
                          <option>4hrs 40kms</option>
                          <option>8hrs 80kms</option>
                        </select>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* Search Button */}
              <button 
                onClick={handleSearch}
                disabled={isCalculating}
                style={{
                  width: '100%',
                  marginTop: '16px',
                  background: `linear-gradient(135deg, ${ACCENT} 0%, #ff3a1f 100%)`,
                  color: '#fff',
                  border: 'none',
                  borderRadius: '16px',
                  padding: '18px',
                  fontSize: '15px',
                  fontWeight: 700,
                  letterSpacing: '1.5px',
                  cursor: isCalculating ? 'not-allowed' : 'pointer',
                  boxShadow: `0 6px 20px rgba(231,18,4,0.35)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  opacity: isCalculating ? 0.7 : 1
                }}
              >
                {isCalculating ? (
                  <>
                    <div className="spinner" style={{ width: '20px', height: '20px', border: '3px solid #fff', borderTop: '3px solid transparent', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
                    SEACHING CABS NEAR BY YOU...
                  </>
                ) : (
                  <>
                    <FiSearch style={{ fontSize: '18px' }} /> SEARCH CABS
                  </>
                )}
              </button>
            </div>
          </div>

          {/* PAN India Presence */}
          <div style={{ padding: '20px 16px 8px', background: 'linear-gradient(135deg, #f2f3f7 0%, #ffffff 100%)', marginTop: '-5px' }}>
            <div style={{ background: '#fff', borderRadius: '24px', padding: '20px 16px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
              <h3 style={{ fontSize: '18px', fontWeight: 700, margin: '0 0 16px', display: 'flex', alignItems: 'center', gap: '8px', color: '#1a1a1a' }}>
                <FaMapMarkedAlt style={{ color: ACCENT }} /> PAN India Presence
              </h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '20px' }}>
                {[
                  { city: 'Chennai', img: 'https://media.istockphoto.com/id/1226340114/photo/puratchi-thalaivar-dr-mgr-central-railway-station-chennai-central-railway-station-india.jpg?s=612x612&w=0&k=20&c=lZjBnWBBoLiApWZUUWP1Vl3XAVdKjYMcgGpItXv_L14=' },
                  { city: 'Bangalore', img: 'https://bangaloretourism.in/images/v2/packages/bangalore-tourism-header.jpg' },
                  { city: 'Mumbai', img: 'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=100' },
                  { city: 'Delhi', img: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=100' },
                ].map((item, index) => (
                  <div key={index} style={{ textAlign: 'center' }}>
                    <div style={{ width: '65px', height: '65px', borderRadius: '20px', overflow: 'hidden', margin: '0 auto 8px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', border: '2px solid #fff' }}>
                      <img src={item.img} alt={item.city} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                    <div style={{ fontSize: '12px', fontWeight: 600, color: '#333' }}>{item.city}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <Cards />
          <WhyRideWithUs />
          <FleetTariffs />
          <SafetySection />
          <AllPopularRoutes onRouteSelect={handleRouteSelect} />
          <section style={{ background: '#fff', padding: '40px 16px' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
              <h2 style={{ fontSize: '24px', fontWeight: 800, color: '#1a1a1a', marginBottom: '8px' }}>
                Explore Chennai Taxi Services
              </h2>
              <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '16px' }}>
                Quick links to our most popular Chennai taxi services and support pages.
              </p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '12px' }}>
                {[
                  { label: 'Cab Services', href: '/cab-services' },
                  { label: 'Airport Taxi', href: '/airport' },
                  { label: 'Outstation Cabs', href: '/outstation' },
                  { label: 'Hourly Rentals', href: '/hourly' },
                  { label: 'Corporate Travel', href: '/corporate' },
                  { label: 'Wedding Fleet', href: '/wedding' },
                  { label: 'Event Transfers', href: '/events' },
                  { label: 'Popular Routes', href: '/popular-routes' },
                  { label: 'Safety Guidelines', href: '/safety' },
                  { label: 'Help Center', href: '/help' },
                  { label: 'Contact Us', href: '/contact' },
                  { label: 'About BookinIndia', href: '/about' }
                ].map((item) => (
                  <Link
                    key={item.href}
                    to={item.href}
                    style={{
                      padding: '12px 14px',
                      borderRadius: '12px',
                      border: '1px solid #f0f0f0',
                      background: '#fafafa',
                      fontSize: '13px',
                      fontWeight: 600,
                      color: '#1f2937',
                      textDecoration: 'none'
                    }}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          </section>
           <FAQ/>
        </div>
      </div>

      <style>{`
        @media (min-width: 768px) {
          .desktop-hero { display: block !important; }
          .mobile-hero { display: none !important; }
        }
        @media (max-width: 767px) {
          .desktop-hero { display: none !important; }
          .mobile-hero { display: block !important; }
        }
        input[type="date"]::-webkit-calendar-picker-indicator,
        input[type="time"]::-webkit-calendar-picker-indicator {
          cursor: pointer;
          opacity: 0.5;
        }
        button:hover { opacity: 0.9; }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes mobileHeroSlide {
          0%, 12% { transform: translateX(0); }
          16%, 28% { transform: translateX(-16.666%); }
          32%, 44% { transform: translateX(-33.333%); }
          48%, 60% { transform: translateX(-50%); }
          64%, 76% { transform: translateX(-66.666%); }
          80%, 92% { transform: translateX(-83.333%); }
          100% { transform: translateX(0); }
        }
        @keyframes slide {
          0%, 25% { transform: translateX(0); }
          33.33%, 58.33% { transform: translateX(-33.333%); }
          66.66%, 91.66% { transform: translateX(-66.666%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </div>
  );
};

export default HeroBookingSection;
